import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Card,
  Button,
  Header,
  Label,
  Icon,
  Confirm,
  Loader
} from 'semantic-ui-react';
import { holidayActions } from '../../actions/holiday.actions';
import { holidayScopeOptions } from '../../constants/holiday.constants';
import { history } from '../../helpers';
import { userConstants } from '../../constants/user.constants';

function labelFor(options, value) {
  const option = options.find(o => o.value === value);
  return option ? option.text : value;
}

function summarizeDate(item) {
  const date = `${String(item.Day).padStart(2, '0')}/${String(item.Month).padStart(2, '0')}`;
  return item.Annual ? `${date} (todo ano)` : `${date}/${item.Year}`;
}

function summarizeLocality(item) {
  const parts = [item.Country, item.State, item.City].filter(x => x);
  return parts.length > 0 ? parts.join(' / ') : 'Todas as localidades';
}

class HolidayIndexScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmOpen: false,
      confirmHoliday: null,
    };
  }

  componentDidMount() {
    this.fetchHolidays();
  }

  fetchHolidays() {
    const { dispatch } = this.props;
    dispatch(holidayActions.fetch());
  }

  showConfirm(holiday) {
    this.setState({ confirmOpen: true, confirmHoliday: holiday });
  }

  closeConfirm() {
    this.setState({ confirmOpen: false, confirmHoliday: null });
  }

  executeConfirm() {
    const { dispatch } = this.props;
    const { confirmHoliday } = this.state;
    dispatch(holidayActions.remove(confirmHoliday.Id)).then(() => this.fetchHolidays());
    this.setState({ confirmOpen: false, confirmHoliday: null });
  }

  render() {
    const { holidays, loading, me } = this.props;

    if (me && me.Role != userConstants.ROLE_ADMIN) {
      window.location.href = "/";
      return;
    }

    return (
      <Fragment>
        <Confirm
          open={this.state.confirmOpen}
          content={this.state.confirmHoliday ? `Tem certeza que deseja remover o feriado "${this.state.confirmHoliday.Name}"?` : ''}
          onCancel={() => this.closeConfirm()}
          onConfirm={() => this.executeConfirm()}
        />
        <Header>
          <h1>Feriados</h1>
        </Header>
        <Loader active={loading} />
        <div style={{ textAlign: "right", marginBottom: "8px" }}>
          <Button primary onClick={() => history.push('/settings/holidays/create')}>Novo Feriado</Button>
        </div>
        <Card.Group>
          {(!holidays || (holidays.Results && holidays.TotalNumberOfRecords === 0)) &&
            <Card header='Nenhum feriado cadastrado' fluid />
          }

          {holidays && holidays.Results && holidays.Results.map((item) => {
            return <Card key={item.Id} fluid>
              <Card.Content>
                <Card.Header>
                  {item.Name}
                  <Label style={{ float: "right" }} color={item.Enabled ? 'green' : 'red'}>
                    {item.Enabled ? 'Ativo' : 'Inativo'}
                  </Label>
                </Card.Header>
                <Card.Description>
                  <p><strong>Data:</strong> {summarizeDate(item)}</p>
                  <p><strong>Abrangência:</strong> {labelFor(holidayScopeOptions, item.Scope)}</p>
                  <p><strong>Localidade:</strong> {summarizeLocality(item)}</p>
                </Card.Description>
              </Card.Content>
              <Card.Content extra>
                <Button size='mini' secondary icon onClick={() => history.push(`/settings/holidays/update/${item.Id}`)}>
                  <Icon name='edit' />
                  Alterar
                </Button>

                <Button size='mini' color='red' icon onClick={() => this.showConfirm(item)}>
                  <Icon name='trash' />
                  Excluir
                </Button>
              </Card.Content>
            </Card>
          })}
        </Card.Group>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { holiday, users } = state;
  return {
    holidays: holiday.holidays || null,
    loading: holiday.loading,
    me: users.me || null
  };
}

const connectedHolidayIndexScreen = connect(mapStateToProps)(HolidayIndexScreen);
export { connectedHolidayIndexScreen as HolidayIndexScreen };
